/**
 * /frontend/src/features/analytics/api/queueAnalyticsApi.js
 */

import { ANALYTICS_ENDPOINTS } from '../constants/analyticsEndpoints';
import { getJson } from './analyticsApiClient';

/**
 * Fetches queue performance KPIs.
 * @param {Function} request
 * @param {string} token
 * @param {string} storeId
 * @param {string} startDate
 * @param {string} endDate
 * @param {string} zoneId
 * @param {string} sectionId
 * @returns {Promise<Object>}
 */
export const getQueuePerformance = async (request, token, storeId, startDate, endDate, zoneId, sectionId) => getJson(
  request,
  ANALYTICS_ENDPOINTS.QUEUE_PERFORMANCE,
  { storeId, startDate, endDate, zoneId, sectionId },
  token,
  'analytics-queue-performance'
);

/**
 * Fetches queue performance trend.
 * @param {Function} request
 * @param {string} token
 * @param {string} storeId
 * @param {string} startDate
 * @param {string} endDate
 * @param {string} granularity
 * @returns {Promise<Object>}
 */
export const getQueuePerformanceTrend = async (request, token, storeId, startDate, endDate, granularity) => getJson(
  request,
  ANALYTICS_ENDPOINTS.QUEUE_PERFORMANCE_TREND,
  { storeId, startDate, endDate, granularity },
  token,
  'analytics-queue-performance-trend'
);

